import { List, SimpleCell } from '@vkontakte/vkui';
import { UserAvatar } from '../../components/UserAvatar';
import PropTypes from 'prop-types';

const MembersListComponent = ({members}) => {
  return (<List>
    {
      (members || []).map((user) => {
        return (<SimpleCell
          disabled={true}
          key={user.id}
          before={<UserAvatar type={user.type} size={48} name={user.name} id={user.id} src={user.img} url={user.link} />}
        >
          {user.name}
        </SimpleCell>);
      })
    }
  </List>);
}

export default MembersListComponent;

const members = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  img: PropTypes.string,
});

MembersListComponent.propTypes = {
  members: PropTypes.arrayOf(members.isRequired).isRequired,
};
